import TypeToReducer from 'type-to-reducer';
import { normalize, schema } from 'normalizr';

import {
  GET_EMPLOYEES_ASSETS_REPORT,
  SET_EMPLOYEES_ASSETS_REPORT_PAGINATION,
  SET_EMPLOYEES_ASSETS_REPORT_FILTERS,
  RESET_EMPLOYEES_ASSETS_REPORT,
} from 'reports/constants';

import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const asset = new schema.Entity('assets');

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: [
      'indexInteger.indexString',
      '_employee.name',
      '_employee.key',
      '_employee.lastname',
      '_employee.position',
    ],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: '_employee.name',
    order: 'asc',
  },
  needFetch: false,
  isLoading: false,
  entities: { assets: {} },
  result: { assets: [] },
};

export const getPending = (state) => ({
  ...state,
  isLoading: true,
  needFetch: false,
});
export const getRejected = (state) => ({ ...state, isLoading: false });

export const getFulfilled = (state, { payload }) => {
  const pagination = {
    ...state.pagination,
    limit: payload.limit,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  };

  const normalized = normalize({ assets: payload.records }, { assets: [asset] });

  return { ...state, isLoading: false, pagination, ...normalized };
};

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

//TODO: este reporte no tiene generacion de CSV?????
const employeesAssetsReportReducers = {
  [GET_EMPLOYEES_ASSETS_REPORT]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [SET_EMPLOYEES_ASSETS_REPORT_PAGINATION]: setPagination,
  [SET_EMPLOYEES_ASSETS_REPORT_FILTERS]: setFilters,
  [RESET_EMPLOYEES_ASSETS_REPORT]: reset,
};

export default TypeToReducer(employeesAssetsReportReducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/reducers/employees_assets_report_reducers.js